import React from 'react';
import './Hero.css';
import profile from '../assets/profile.jpg';

function Hero() {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <img src={profile} alt="Profile" className="hero-image" />

        <h1 className="hero-title">
          Hi, I'm <span className="highlight">Bibek Khadka</span>
        </h1>

        <h2 className="hero-subtitle">
          Aspiring Data Scientist | Web Developer | Problem Solver
        </h2>

        <p className="hero-description">
          I am a Computer Science student passionate about transforming ideas 
          into impactful digital solutions. My main interests lie in 
          <strong> Data Science</strong> and <strong> Web Development</strong>, 
          where I enjoy working with data to uncover insights and building 
          responsive, user-friendly web applications.
        </p>

        <p className="hero-description">
          I have experience with technologies like 
          <strong> Python, SQL, Machine Learning, React, JavaScript, Node.js,</strong> 
          and modern web tools. I’m constantly learning, exploring new technologies, 
          and seeking opportunities to create meaningful projects that solve real-world problems.
        </p>
      </div>
    </section>
  );
}

export default Hero;